module.exports = __webpack_public_path__ + "static/other/gameWarehousePhysics.4fbc5dba.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameWarehousePhysics.json
// module id = 2401
// module chunks = 0